﻿import {gsap} from "gsap";
import {NUtils} from "../../Utils/NUtils";
import {UILabeledIcon} from "./Base/UILabeledIcon";
import {Core} from "../../Base/Core";

export class ClickBonusUI extends UILabeledIcon {

    static ShowCoins(n, position) {
        if (!GameManager.gameView || !GameManager.gameView.vfxContainer) return;
        let fx = GameManager.gameView.vfxContainer.addChild(new this());
        fx._showNormal(NUtils.FormatMoney(n), position)
    }

    static ShowTapChallenge() {
        // TODO: implement VFX
    }

    Awake() {
        this._kill = this._kill.bind(this);
    }

    _kill() {
        if (this.parent) {
            this.parent.removeChild(this);
        }
    }

    _showNormal(label, worldPosition) {
        this.position.copyFrom(worldPosition);

        let size = Core.app.viewport.width * 0.05, w = size * 4, h = size;

        let fx = this.addChild(new UILabeledIcon({label, icon: "ico-gold", iconSize: 1}));
        fx.fitLayout(new PIXI.Rectangle(-w * 0.5, -h * 0.5, w, h));

        this.alpha = 0;
        gsap.timeline()
            .eventCallback("onComplete", this._kill)
            .eventCallback("onInterrupt", this._kill)
            .set(this, {alpha: 1}, 0.1)
            .to(this, {duration: 2, ease: "power3.out", y: this.y - 200}, 0.1)
            .to(this, {duration: 1, ease: "power3.out", alpha: 0}, 1.1)
        ;
    }

    _showTapChallenge(worldPosition) {
        // TODO: VFX
    }
}
